export default "__VITE_ASSET__DkD$YcEz__"